import { render } from "./ItemModalButton.vue?vue&type=template&id=650d4ea2&scoped=true"
import script from "./ItemModalButton.vue?vue&type=script&lang=js"
export * from "./ItemModalButton.vue?vue&type=script&lang=js"

import "./ItemModalButton.vue?vue&type=style&index=0&id=650d4ea2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-650d4ea2"

export default script